export const WHITE = '#FFFFFF';
export const BLUE = '#0078FF';
export const TEAL_BLUE = '#00CAFF';
export const ORANGE = '#FF8F00';
export const ROSE_MADDER = '#E71D36';
export const GREEN = '#2DD070';
export const JUNGLE_GREEN = '#1B998B';
export const PORTLAND_ORANGE = '#F46036';
export const VERDIGRIS = '#5ABCB9';
export const GOLDENROD = '#D5A021';
export const PURPLE = '#5A51DE';
export const BDAZZLED_BLUE = '#2F6690';
export const PINK = '#FF004F';
export const RED = '#E3111A';
export const BRONZE = '#C67C3B';
export const TIFFANY = '#1ACEB3';
export const YELLOW = '#FFC800';
export const ORCHID = '#B959FF';
export const BLACK = '   #000';
export const BLACK_RAISIN = '#212734';
export const DEFAULT = '#212734';
export const BLACK_CHAROCOAL = '#31394C';
export const CHAROCOAL = BLACK_CHAROCOAL;
export const PAYNES_GRAY = '#3D465E';
export const GRAY = '#F0F0F0';
export const GRAY_BLUE = '#5a6268';
export const DARK_LIME = '#28a745';
export const BRIGHT_RED = '#dc3545';
export const VIVID_YELLOW = '#ffc107';
export const STRONG_CYAN = '#17a2b8';
export const GRAY_LIGHT = '#f8f9fa';

export const PRIMARY = BLUE;
export const SECONDARY = GRAY_BLUE;
export const SUCCESS = DARK_LIME;
export const DANGER = BRIGHT_RED;
export const WARNING = VIVID_YELLOW;
export const INFO = STRONG_CYAN;
export const DARK = PAYNES_GRAY;
export const LIGHT = GRAY_LIGHT;

export const colors = {
  WHITE,
  BLUE,
  TEAL_BLUE,
  ORANGE,
  ROSE_MADDER,
  GREEN,
  JUNGLE_GREEN,
  PORTLAND_ORANGE,
  VERDIGRIS,
  GOLDENROD,
  PURPLE,
  BDAZZLED_BLUE,
  PINK,
  RED,
  BRONZE,
  TIFFANY,
  YELLOW,
  ORCHID,
  BLACK,
  BLACK_RAISIN,
  DEFAULT,
  BLACK_CHAROCOAL,
  CHAROCOAL,
  PAYNES_GRAY,
  GRAY,
  GRAY_BLUE,
  DARK_LIME,
  BRIGHT_RED,
  VIVID_YELLOW,
  STRONG_CYAN,
  GRAY_LIGHT,

  PRIMARY,
  SECONDARY,
  SUCCESS,
  DANGER,
  WARNING,
  INFO,
  DARK,
  LIGHT,
};
